// extracted by mini-css-extract-plugin
module.exports = {"container":"SrBankAccountCard--container--2FqrP","flex1":"SrBankAccountCard--flex1--2S6Ku","highlightYellowFadeIn":"SrBankAccountCard--highlightYellowFadeIn--3TjkB"};